export enum HealthStatus {
    HEALTHY = 'healthy',
    UNHEALTHY = 'unhealthy',
    DEGRADED = 'degraded',
}

export interface HealthCheckResult {
    status: HealthStatus
    message: string
    responseTime?: number
    error?: string
}

export interface ServerCheck extends HealthCheckResult {
    status: HealthStatus
    message: string
}

export interface EnvironmentCheck extends HealthCheckResult {
    status: HealthStatus
    message: string
    missingVariables?: string[]
}

export interface DependencyCheck extends HealthCheckResult {
    name: string
    status: HealthStatus
    message: string
    responseTime?: number
    error?: string
}

export interface StartupHealthResponse {
    status: HealthStatus
    timestamp: string
    checks?: {
        server: ServerCheck
        environment?: EnvironmentCheck
    }
}

export interface LivenessHealthResponse {
    status: HealthStatus
    timestamp: string
    checks?: {
        server: ServerCheck
    }
}

export interface ReadinessHealthResponse {
    status: HealthStatus
    timestamp: string
    checks?: {
        server: ServerCheck
        dependencies?: DependencyCheck[]
    }
}

/**
 * Result of a health check operation.
 */
export interface TimeoutCheckResult {
    /** Name of the service/endpoint being checked */
    name: string
    /** Health status of the check */
    status: HealthStatus
    /** Human-readable message describing the check result */
    message: string
    /** Response time in milliseconds */
    responseTime: number
    /** Error message if the check failed */
    error?: string
}

export interface ValidatedDependencyCheck {
    overallHealthStatus: HealthStatus
    dependencies: DependencyCheck[]
}
